import React from "react";

function circularDistance(a, b, total) {
  if (!Number.isFinite(total) || total <= 0) return Math.abs(a - b);
  const diff = Math.abs(a - b);
  return Math.min(diff, total - diff);
}

export default function SlickLazyImage({
  src,
  alt,
  className,
  style,
  index,
  activeIndex,
  total,
  buffer = 1,
  eager = false,
}) {
  const isFirst = index === 0;
  const isEager = Boolean(eager) && isFirst;

  const distance = circularDistance(index ?? 0, activeIndex ?? 0, total);
  const shouldPrioritize = isEager || distance <= buffer;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      decoding="async"
      loading={isEager ? "eager" : "lazy"}
      fetchPriority={isEager ? "high" : shouldPrioritize ? "auto" : "low"}
    />
  );
}
